const host = window.location.host;
export const subDomain = host.split('.')[0];

export const isLocalhost =
  host.includes('127.0.0.1') || host.includes('localhost');

export const isTest = process.env.NODE_ENV === 'test';

export const isCrexta =
  subDomain === 'crexta' ||
  subDomain === 'panacloud-crexta' ||
  subDomain === 'panalyt-crexta';
